<div class="hiring-request-main-container">
  <div class="navigation-breadcrumb">
    <span class="breadcrumb-text" (click)="navigateToVendorManagement()">
      {{ routesEnum.RaiseHiringRequestBreadcrumb }}
    </span>
  </div>

  <div class="hiring-request-form">
    <h2 class="hiring-request-heading">Raise Hiring Request</h2>
    <div *ngIf="isLoading" class="loader-overlay">
      <div class="loader"></div>
    </div>
    <form
      [formGroup]="hiringRequestForm"
      (keydown.enter)="preventEnterKey($event)"
      *ngIf="!isLoading"
    >
      <div class="section-container">
        <div class="section-title">Project Details</div>
        <div class="section-form">
          <ng-container *ngIf="lobOptions">
            <emerald-dropdown
              [options]="lobOptions"
              [id]="'single_select'"
              [label]="'Line of Business'"
              [outlined]="true"
              [showFilter]="true"
              [isValid]="isFieldValid('lineOfBusiness')"
              [errorText]="getFieldError('lineOfBusiness')"
              formControlName="lineOfBusiness"
              (onChangeValue)="onLobChange($event)"
            >
            </emerald-dropdown>
          </ng-container>
          <emerald-dropdown
            [options]="DntOptions"
            [id]="'single_select'"
            [label]="'D&T India Leader'"
            [outlined]="true"
            [isValid]="isFieldValid('dntLeader')"
            [errorText]="getFieldError('dntLeader')"
            formControlName="dntLeader"
            (onChangeValue)="onDntChange($event)"
          >
          </emerald-dropdown>
          <ng-container>
            <emerald-dropdown
              [options]="projectNameOptions"
              [id]="'single_select'"
              [label]="'Project Name'"
              [outlined]="true"
              [showFilter]="true"
              [isValid]="isFieldValid('projectName')"
              [errorText]="getFieldError('projectName')"
              formControlName="projectName"
            >
            </emerald-dropdown>
          </ng-container>
        </div>
      </div>

      <emerald-divider
        [vertical]="false"
        [isWhite]="false"
        [allowMargin]="true"
        [title]="'horizontal divider'"
      ></emerald-divider>

      <div class="section-container">
        <div class="section-title">Requirements</div>
        <div class="section-form">
          <ng-container>
            <emerald-input
              [label]="'Job Title'"
              [outlined]="true"
              [isValid]="isFieldValid('jobTitle')"
              [errorText]="getFieldError('jobTitle')"
              formControlName="jobTitle"
            ></emerald-input>
          </ng-container>

          <emerald-input
            [label]="'Number of positions'"
            [outlined]="true"
            [maxLength]="maxLengthThree"
            [isValid]="isFieldValid('numberOfPositions')"
            [errorText]="getFieldError('numberOfPositions')"
            formControlName="numberOfPositions"
            (input)="onInput($event, 'numberOfPositions')"
          >
          </emerald-input>

          <ng-container *ngIf="jobLocation">
            <emerald-dropdown
              [options]="jobLocation"
              [id]="'multi_select'"
              [label]="'Job Location'"
              [outlined]="true"
              [multiSelect]="true"
              [isValid]="isFieldValid('jobLocation')"
              [errorText]="getFieldError('jobLocation')"
              formControlName="jobLocation"
              preSelectedValue="defaultValue"
              preSelectedLabel="defaultLabel"
            >
            </emerald-dropdown>
          </ng-container>

          <div>
            <emerald-input
              [label]="'Years of Overall Experience'"
              [outlined]="true"
              [isValid]="isFieldValid('overAllExp')"
              [errorText]="getFieldError('overAllExp')"
              formControlName="overAllExp"
              (input)="onFieldChange($event, 'overAllExp')"
            >
            </emerald-input>
            <div
              class="field-error"
              *ngIf="hiringRequestForm.get('overAllExp')?.invalid"
            >
              <span
                class="field-error-message"
                *ngIf="
                  hiringRequestForm.get('overAllExp')?.errors?.[
                    'maxOverallExperience'
                  ] ||
                  hiringRequestForm.get('overAllExp')?.errors?.['negativeValue']
                "
              >
                {{ hiringRequestText.overallExperienceError }}
              </span>
            </div>
          </div>
          <div>
            <emerald-input
              [label]="'Years of Relevant Experience'"
              [outlined]="true"
              [isValid]="isFieldValid('relExp')"
              [errorText]="getFieldError('relExp')"
              formControlName="relExp"
              (input)="onFieldChange($event, 'relExp')"
            >
            </emerald-input>
            <div
              class="field-error"
              *ngIf="
                hiringRequestForm.get('overAllExp')?.invalid ||
                hiringRequestForm.get('relExp')?.invalid
              "
            >
              <span
                class="field-error-message"
                *ngIf="
                  hiringRequestForm.get('relExp')?.errors?.[
                    'maxOverallExperience'
                  ] ||
                  hiringRequestForm.get('relExp')?.errors?.['negativeValue']
                "
              >
                {{ hiringRequestText.overallExperienceError }}
              </span>
              <span
                class="field-error-message"
                *ngIf="
                  hiringRequestForm.get('relExp')?.errors?.[
                    'relevantExperienceExceeds'
                  ]
                "
              >
                {{ hiringRequestText.relevantExperienceError }}
              </span>
            </div>
          </div>

          <div>
            <emerald-datepicker
              [label]="'Desired Start Date'"
              [isOutlined]="true"
              [forceRefresh]="true"
              [minDate]="currentDate"
              [keepInvalid]="isFieldValid('startDate')"
              [required]="true"
              formControlName="startDate"
              (keypress)="preventInvalidKeyPress($event)"
            >
            </emerald-datepicker>

            <div
              class="field-error"
              *ngIf="hiringRequestForm.get('startDate')?.invalid"
            >
              <span
                class="field-error-message"
                *ngIf="
                  isSubmitted &&
                  hiringRequestForm.get('startDate')?.errors?.['required']
                "
                >This field can not be blank</span
              >
              <span
                class="field-error-message"
                *ngIf="
                  hiringRequestForm.get('startDate')?.errors?.[
                    'invalidDateFormat'
                  ]
                "
                >Invalid date format
              </span>
              <span
                class="field-error-message"
                *ngIf="
                  hiringRequestForm.get('startDate')?.errors?.['invalidDate']
                "
                >Start date must be atleast 3 days from today</span
              >
            </div>
          </div>

          <ng-container *ngIf="mandatorySkillOptions">
            <emerald-dropdown
              #mandatorySkillOptionsDropDown
              [options]="mandatorySkillOptions"
              [id]="'multi_select'"
              [label]="'Primary Skills'"
              [outlined]="true"
              [multiSelect]="true"
              [showFilter]="true"
              [isValid]="isFieldValid('mandatorySkills')"
              [errorText]="getFieldError('mandatorySkills')"
              formControlName="mandatorySkills"
              [useLazyLoading]="true"
              [maxVisisbleOptions]="25"
              (change)="onPrimarySkillsChange()"
            >
            </emerald-dropdown>
          </ng-container>

          <ng-container *ngIf="gthSkillOptions">
            <emerald-dropdown
              #gthSkillOptionsDropDown
              class="hr-optional"
              [options]="gthSkillOptions"
              [id]="'multi_select'"
              [label]="'Secondary Skills'"
              [outlined]="true"
              [multiSelect]="true"
              [showFilter]="true"
              formControlName="goodToHaveSkills"
              [useLazyLoading]="true"
              [maxVisisbleOptions]="25"
              (change)="onGoodToHaveSkillsChange()"
            >
            </emerald-dropdown>
          </ng-container>

          <div class="form-group">
            <textarea
              id="comment"
              class="emerald-textarea"
              rows="3"
              formControlName="comment"
              placeholder="Comments"
            ></textarea>
          </div>

          <div class="upload-container">
            <label class="upload-jd-label">Upload Job Description (JD)<em>*</em></label>

            <div class="upload-info" (click)="fileUpload.click()">
              <label class="upload-label">
                Select file(s) or drop here to upload
                <span class="valid-file-info">
                  PDF or word formats, up to 10 MB.
                </span>
              </label>
              <emerald-button [type]="'Light'">Browse file</emerald-button>
              <input
                type="file"
                id="file-upload"
                class="file-input"
                (change)="onFileSelected($event)"
                formControlName="jobDescription"
                #fileUpload
              />
            </div>
            <div
              class="field-error"
              *ngIf="
                fileError ||
                (isSubmitted &&
                  hiringRequestForm.get('jobDescription')?.invalid)
              "
            >
              <span
                class="field-error-message"
                *ngIf="
                  hiringRequestForm.get('jobDescription')?.errors?.['required']
                "
                >This field can not be blank</span
              >
              <span class="field-error-message" *ngIf="fileError">{{
                fileError
              }}</span>
            </div>
          </div>
          <div *ngIf="selectedFile" class="selected-file">
            <emerald-icon [icon]="'insert_drive_file'"></emerald-icon>
            <div class="file-info">
              <span class="file-name">{{ selectedFile }}</span>
              <emerald-icon [icon]="'check_circle'"></emerald-icon>
              <span class="file-size">{{ fileSize }}</span>
            </div>
            <emerald-icon
              [icon]="'delete'"
              (click)="onDeleteFile()"
            ></emerald-icon>
          </div>
        </div>
      </div>

      <emerald-divider
        [vertical]="false"
        [isWhite]="false"
        [allowMargin]="true"
        [title]="'horizontal divider'"
      ></emerald-divider>

      <div class="section-container">
        <div class="section-title">Manager Details</div>
        <div class="section-form">
          <ng-container *ngIf="hiringManagerOptions">
            <emerald-dropdown
              #hiringManagerOptionsDropDown
              [options]="hiringManagerOptions"
              [id]="'single_select'"
              [label]="'Hiring Manager'"
              [outlined]="true"
              [showFilter]="true"
              [isValid]="isFieldValid('hiringManager')"
              [errorText]="getFieldError('hiringManager')"
              formControlName="hiringManager"
              (onChange)="onEmployeeChange($event)"
              [useLazyLoading]="true"
              [maxVisisbleOptions]="25"
            >
            </emerald-dropdown>
          </ng-container>

          <emerald-input
            [label]="'Hiring Manager Email'"
            [outlined]="true"
            [isValid]="isFieldValid('hirManEmail')"
            [errorText]="getFieldError('hirManEmail')"
            formControlName="hirManEmail"
            [value]="selectedEmployeeEmail"
            [readOnly]="true"
          >
          </emerald-input>
        </div>
      </div>

      <emerald-divider
        [vertical]="false"
        [isWhite]="false"
        [allowMargin]="true"
        [title]="'horizontal divider'"
      ></emerald-divider>

      <div class="section-container">
        <div class="section-title">Screening and Evaluation</div>
        <div class="section-form">
          <ng-container *ngIf="panelMemberOneOptions">
            <emerald-dropdown
              #panelMemberOneOptionsDropDown
              [options]="panelMemberOneOptions"
              [id]="'single_select'"
              [label]="'Interview Round 1 Panel Member'"
              [outlined]="true"
              [showFilter]="true"
              [isValid]="isFieldValid('panelMemberOne')"
              [errorText]="getFieldError('panelMemberOne')"
              formControlName="panelMemberOne"
              [useLazyLoading]="true"
              [maxVisisbleOptions]="25"
            >
            </emerald-dropdown>
          </ng-container>

          <ng-container *ngIf="timeZoneOneOptions">
            <emerald-dropdown
              [options]="timeZoneOneOptions"
              [id]="'single_select'"
              [label]="'Panel Member\'s Availability - Time Zone'"
              [outlined]="true"
              [showFilter]="true"
              [isValid]="isFieldValid('panelMemberOneTimezone')"
              [errorText]="getFieldError('panelMemberOneTimezone')"
              formControlName="panelMemberOneTimezone"
              preSelectedValue=" "
              preSelectedLabel=" "
            >
            </emerald-dropdown>
          </ng-container>

          <ng-container *ngIf="panelMemberTwoOptions">
            <emerald-dropdown
              #panelMemberTwoOptionsDropDown
              class="hr-optional"
              [options]="panelMemberTwoOptions"
              [id]="'single_select'"
              [label]="'Interview Round 2 Panel Member'"
              [outlined]="true"
              [showFilter]="true"
              [isValid]="isFieldValid('panelMemberTwo')"
              [errorText]="getFieldError('panelMemberTwo')"
              formControlName="panelMemberTwo"
              [useLazyLoading]="true"
              [maxVisisbleOptions]="25"
            >
            </emerald-dropdown>
          </ng-container>

          <ng-container *ngIf="timeZoneTwoOptions">
            <emerald-dropdown
              class="hr-optional"
              [options]="timeZoneTwoOptions"
              [id]="'single_select'"
              [label]="'Panel Member\'s Availability - Time Zone'"
              [outlined]="true"
              [showFilter]="true"
              [isValid]="isFieldValid('panelMemberTwoTimezone')"
              [errorText]="getFieldError('panelMemberTwoTimezone')"
              formControlName="panelMemberTwoTimezone"
              preSelectedValue=" "
              preSelectedLabel=" "
            >
            </emerald-dropdown>
          </ng-container>
          <ng-container formArrayName="panelMembers">
            <div
              *ngFor="let panelMember of panelMembers.controls; let i = index"
              [formGroupName]="i"
              class="panel-member-row"
            >
              <ng-container>
                <div class="panel-member-col">
                  <emerald-dropdown
                    class="panel-member-dropdown hr-optional"
                    [options]="dynamicPanelMemberOptions"
                    [id]="'dynamic_single_select_' + i"
                    [label]="'Interview Round ' + (i + 3) + ' Panel Member'"
                    [outlined]="true"
                    [showFilter]="true"
                    [isValid]="
                      panelMember?.get('panelMember')?.valid || !isSubmitted
                    "
                    [errorText]="
                      getFieldError('panelMembers.' + i + '.panelMember')
                    "
                    formControlName="panelMember"
                    [useLazyLoading]="true"
                    [maxVisisbleOptions]="25"
                    preSelectedValue=" "
                    preSelectedLabel=" "
                  >
                  </emerald-dropdown>
                  <span
                    class="field-error-update"
                    *ngIf="hasPanelMemberPairError(panelMember, 'panelMember')"
                  >
                    {{ hiringRequestText.requiredFieldError }}
                  </span>
                </div>
              </ng-container>

              <ng-container>
                <div class="panel-member-col">
                  <emerald-dropdown
                    class="panel-member-timezone hr-optional"
                    [options]="dynamicTimeZoneOptions"
                    [id]="'dynamic_single_select_timezone_' + i"
                    [label]="'Panel Member\'s Availability - Time Zone'"
                    [outlined]="true"
                    [showFilter]="true"
                    [isValid]="
                      panelMember?.get('panelMemberTimezone')?.valid ||
                      !isSubmitted
                    "
                    [errorText]="
                      getFieldError(
                        'panelMembers.' + i + '.panelMemberTimezone'
                      )
                    "
                    formControlName="panelMemberTimezone"
                    preSelectedValue=" "
                    preSelectedLabel=" "
                  >
                  </emerald-dropdown>
                  <span
                    class="field-error-update"
                    *ngIf="
                      hasPanelMemberPairError(
                        panelMember,
                        'panelMemberTimezone'
                      )
                    "
                  >
                    {{ hiringRequestText.requiredFieldError }}
                  </span>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
        <div class="add-button-container">
          <emerald-button
            [type]="'Light'"
            (click)="addPanelMember()"
            aria-label="Add more panel members"
            >+ Add More</emerald-button
          >
        </div>
      </div>

      <emerald-divider
        [vertical]="false"
        [isWhite]="false"
        [allowMargin]="true"
        [title]="'horizontal divider'"
      ></emerald-divider>

      <div class="section-container">
        <div class="section-title">Share with vendors</div>
        <div class="section-form">
          <ng-container *ngIf="vendorOptions">
            <emerald-dropdown
              [options]="vendorOptions"
              [id]="'multi_select'"
              [label]="'Select Vendors'"
              [outlined]="true"
              [multiSelect]="true"
              [showSelectAll]="true"
              [showFilter]="true"
              [isValid]="isFieldValid('vendors')"
              [errorText]="getFieldError('vendors')"
              formControlName="vendors"
            >
            </emerald-dropdown>
          </ng-container>
          <emerald-dropdown
            [options]="priorityOptions"
            [id]="'single_select'"
            [label]="'Priority'"
            [outlined]="true"
            [isValid]="isFieldValid('priorityOptions')"
            [errorText]="getFieldError('priorityOptions')"
            formControlName="priorityOptions"
            preSelectedValue=" "
            preSelectedLabel=" "
          >
          </emerald-dropdown>
        </div>
      </div>

      <div class="button-container">
        <emerald-button [type]="'Secondary'" (onClick)="onCancel()"
          >Cancel</emerald-button
        >

        <emerald-button [type]="'Primary'" (onClick)="onPublish()"
          >Publish the Request</emerald-button
        >
      </div>
    </form>
  </div>
</div>
